import { render, staticRenderFns } from "./LivePlayers.vue?vue&type=template&id=308d14ae&scoped=true"
import script from "./LivePlayers.js?vue&type=script&lang=js&external"
export * from "./LivePlayers.js?vue&type=script&lang=js&external"
import style0 from "./LivePlayers.vue?vue&type=style&index=0&id=308d14ae&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "308d14ae",
  null
  
)

export default component.exports